import { render, staticRenderFns } from "./KaoqinView.vue?vue&type=template&id=197d9fa5&scoped=true"
import script from "./KaoqinView.vue?vue&type=script&lang=js"
export * from "./KaoqinView.vue?vue&type=script&lang=js"
import style0 from "./KaoqinView.vue?vue&type=style&index=0&id=197d9fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d9fa5",
  null
  
)

export default component.exports